import timeTrackingHeaderIllustration from '../../../../ui/assets/timeTrackingHeaderIllustration.svg';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { PageHeaderWithImage } from '@juvare/common-web-ui/PageHeader';
import React from 'react';
import { TimeTrackingPlaceholders } from './TimeTrackingPlaceholders';
export const TimeTrackingHeader = ({ approvedMissions, approvedShifts, approvedHours }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(PageHeaderWithImage, { gradient: 'green-light', title: t('timeTracking.title'), subtitle: t('timeTracking.totals'), image: timeTrackingHeaderIllustration, imageAlt: t('timeTracking.illustrationAlt') },
        React.createElement(TimeTrackingPlaceholders, { approvedMissions: approvedMissions, approvedShifts: approvedShifts, approvedHours: approvedHours })));
};
